import React, { useState, useEffect, useCallback, useRef } from "react";
import { set, useForm, Controller } from "react-hook-form";
import {
  FaToggleOn,
  FaToggleOff,
  FaPen,
  FaStar,
  FaKey,
  FaUserPlus,
} from "react-icons/fa";
import "../../Complaint.css";
import "bootstrap/dist/css/bootstrap.min.css";
import toast from "react-hot-toast";
import * as PartnerUserService from "../../Services/Partner/PartnerUserService";
import { ActivateDeactivateUser } from "../../Services/User/UserService";
import "react-datepicker/dist/react-datepicker.css";
import { store } from "../../Store/store";
import "../../Common/CommonStyles.css";
import MultiSelect from "multiselect-react-dropdown";
import { GetAccessControlMasterList } from "../../Services/User/UserService";
import "./MHL_PartnerUserModalComponent.css";
import * as PartnerService from "../../Services/Partner/PartnerService";
import ExtendUserComponent from "./ExtendUserComponent";
import CommonConfirmationModal from "../../Common/CommonConfirmationModal";

const MHL_PartnerUserModalComponent = (props) => {
  const { handleNewPartnerUserClose, selectedPartnerDet } = props;
  const [filteredPartnerUserList, setFilteredPartnerUserList] = useState([]);
  const [ActiveRoleList, setActiveRoleList] = useState([]);

  const {
    register,
    handleSubmit,
    formState: { errors },
    reset,
    setValue,
  } = useForm();

  const [selectedPartnerUser, setSelectedPartnerUser] = useState({});
  //check if primary user check box is selected and exist for partner user;
  const [isPrimaryPartnerUserExist, setIsPrimaryPartnerUserExist] = useState([
    false,
  ]);
  // const [SearchLoading, setSearchLoading] = useState(false);
  // const selectedSearchPartnerUser = useRef();
  const [accessControlMasterList, setAccessControlMasterList] = useState([]);

  const [currentPage, setCurrentPage] = useState(1);
  const [itemsPerPage, setItemsPerPage] = useState(50); // Set number of items per page
  const [extendUserList, setExtendUserList] = useState(false);
  const [extendUserSearch, setExtendUserSearch] = useState("");
  const [extendUserResults, setExtendUserResults] = useState([]);

  //Extension states
  const [selectedExtendUser, setSelectedExtendUser] = useState(null);
  const [selectedRoles, setSelectedRoles] = useState([]);
  const [roleDropdownOpen, setRoleDropdownOpen] = useState(false);
  const [activePartnerList, setActivePartnerList] = useState([]);
  const [partnerSearch, setPartnerSearch] = useState("");
  const [partnerSearchResults, setPartnerSearchResults] = useState([]);

  ///Extension states
  const [parentPartnerCode, setParentPartnerCode] = useState("");
  const [activeRolesForExtension, setActiveRolesForExtension] = useState([]);
  const [childPartnerCode, setChildPartnerCode] = useState(null);
  const [partnerUserId, setPartnerUserId] = useState(null);
  const [partnerExtensionList, setPartnerExtensionList] = useState([]);

  const [selectedPartners, setSelectedPartners] = useState([]);
  const [filteredOptions, setFilteredOptions] = useState([]);
  const [searchText, setSearchText] = useState("");
  const [changedRoleId, setChangedRoleId] = useState("");

  const [showConfirmationModal, setShowConfirmationModal] = useState(false);
  const [modalLoader, setModalLoader] = useState(false);
  const [selectedPartnerUserForToggle, setSelectedPartnerUserForToggle] = useState(null);

  const indexOfLastPartnerUser = currentPage * itemsPerPage;
  const indexOfFirstPartnerUser = indexOfLastPartnerUser - itemsPerPage;
  const currentPartnerUsers = filteredPartnerUserList.slice(
    indexOfFirstPartnerUser,
    indexOfLastPartnerUser
  );

  const partnerUserInfo = store.getState();
  const [loading, setLoading] = useState(false);

  const multiSelectRef = useRef(null);

  const handleResetSelection = () => {
    // Reset the component directly
    if (multiSelectRef.current) {
      multiSelectRef.current.resetSelectedValues();
    }

    // Also update your state
    setAccessControlMasterList((prevList) =>
      prevList.map((item) => ({ ...item, IsSelected: false }))
    );
  };

  const fetchPartnerUserList = useCallback(() => {
    //debugger;
    setLoading(true);
    PartnerUserService.GetUniversalFilterPartnerUserData(
      selectedPartnerDet.Partner_Code,
      ""
    )
      .then(({ data }) => {
        if (data.IsSuccess) {
          setFilteredPartnerUserList(data.Data);
        } else {
          setFilteredPartnerUserList([]);
        }
      })
      .catch(() => toast.error("Something went wrong."))
      .finally(() => setLoading(false));
  }, []);

  useEffect(() => {
    //debugger;
    // //console.log(selectedPartnerDet);
    GetPartnerUserDependedFeildDataList(selectedPartnerDet.Partner_Code);
    fetchPartnerUserList();
    fetchAccessControlMasterList(null, selectedPartnerDet.Partner_Code);

    handleGetPartnerUserDependedFeildDataListForExtension();
  }, [fetchPartnerUserList]);

  const handleGetPartnerUserDependedFeildDataListForExtension = (
          partnerCode
      ) => {
          PartnerUserService.GetPartnerUserDependedFeildDataList(partnerCode)
              .then(({ data }) => {
                  //debugger;
                  if (data.IsSuccess) {
                      setActiveRolesForExtension(data.Data.RoleList);
                  } else {
                      setActiveRolesForExtension([]);
                  }
              })
              .catch(() => toast.error("Something went wrong."))
              .finally(
                  () => { }
                  //setLoading(false)
              );
      };

  const handleViewPartnerUserDetailById = (partnerUserId) => {
    //debugger;
    fetchAccessControlMasterList(
      partnerUserId,
      selectedPartnerDet.Partner_Code
    );
    //debugger;
    PartnerUserService.GetPartnerUserDetailById(partnerUserId)
      .then(({ data }) => {
        if (data.IsSuccess) {
          //debugger;
          reset();
          setSelectedPartnerUser(data.Data);
          setValue("RoleId", data.Data.RoleId.toString());
        } else {
          setSelectedPartnerUser({});
          // toast.error("No Data found for selected range");
        }
      })
      .catch(() => toast.error("Something went wrong."))
      .finally(
        () => { }
        //setLoading(false)
      );
  };

  const handleStaffSendPassword = (staffId) => {
    //debugger;
    PartnerUserService.SendPassword(staffId)
      .then(({ data }) => {
        if (data.IsSuccess) {
          toast.success("Credentials sent successfully");
        } else {
          toast.error(data.ResponseMessage);
        }
      })
      .catch(() => toast.error("Something went wrong."))
      .finally(
        () => { }
        //setLoading(false)
      );
  };

  const fetchAccessControlMasterList = (userid, partnerCode) => {
    GetAccessControlMasterList(userid, partnerCode)
      .then((data) => {
        //debugger;
        if (data.data.IsSuccess) {
          setAccessControlMasterList(data.data.Data);
        } else {
          setAccessControlMasterList();
        }
      })
      .catch((error) => {
        toast.error("Something went wrong");
      })
      .finally(() => { });
  };

  const onSubmit = (data) => {
    data.UserRightsDet = accessControlMasterList;
    setLoading(true);
    if (selectedPartnerUser?.UserId) {
      data.UserId = selectedPartnerUser?.UserId;
      PartnerUserService.UpdatePartnerUser(data)
        .then(({ data }) => {
          //debugger;
          if (data.IsSuccess) {
            fetchPartnerUserList();
            toast.success("Partner staff updated successfully!");
            // handleNewPartnerUserClose();
            handleCancel();
          } else {
            toast.error(data.ResponseMessage);
          }
        })
        .catch(() => toast.error("Something went wrong during update."))
        .finally(() => {
          setLoading(false);
        });
    } else {
      PartnerUserService.CreatePartnerUser(data)
        .then(({ data }) => {
          //debugger;
          if (data.IsSuccess) {
            fetchPartnerUserList();
            // GetPartnerUserDependedFeildDataList();
            toast.success("Partner staff saved successfully!");
            // handleNewPartnerUserClose();
            handleCancel();
          } else {
            toast.error(data.ResponseMessage);
          }
        })
        .catch(() => toast.error("Something went wrong during creation."))
        .finally(() => {
          setLoading(false);
        });
    }
  };

  const GetPartnerUserDependedFeildDataList = (partner_code) => {
    PartnerUserService.GetPartnerRole_By_PartnerAndBusinessType(partner_code)
      .then(({ data }) => {
        //debugger;
        if (data.IsSuccess) {
          setActiveRoleList(data?.Data);
        } else {
        }
      })
      .catch(() => toast.error("Something went wrong."))
      .finally(
        () => { }
        //setLoading(false)
      );
  };

  // const handleActivateDeActivatePartnerUser = (rec) => {

  //   ActivateDeactivateUser(rec.UserId, !rec.IsActive).then(data => {
  //     if (data.data.IsSuccess) {
  //       const message = rec.IsActive ? "Partner staff DeActivated Successfully" : "Partner staff Activated Successfully";
  //       toast.success(message);
  //       fetchPartnerUserList();
  //     } else {
  //       toast.error("Somthing went wrong");
  //     }
  //   }).catch(error => {
  //     toast.error("Somthing went wrong");
  //   })

  // };

  const handleActivateDeActivatePartnerUser = (rec) => {
    PartnerUserService.ActivateDeactivatePartnerUser(rec.UserId, !rec.IsActive)
      .then((data) => {
        if (data.data.IsSuccess) {
          const message = rec.IsActive
            ? "Partner staff DeActivated Successfully"
            : "Partner staff Activated Successfully";
          toast.success(message);
          fetchPartnerUserList();
        } else {
          toast.error(data.data.ResponseMessage);
        }
      })
      .catch((error) => {
        toast.error("Somthing went wrong");
      });
  };

  const handleConfirmToggle = () => {
    setModalLoader(true);
    PartnerUserService.ActivateDeactivatePartnerUser(selectedPartnerUserForToggle.UserId, !selectedPartnerUserForToggle.IsActive)
      .then((data) => {
        if (data.data.IsSuccess) {
          const message = selectedPartnerUserForToggle.IsActive
            ? "Partner staff DeActivated Successfully"
            : "Partner staff Activated Successfully";
          toast.success(message);
          fetchPartnerUserList();
          setShowConfirmationModal(false);
        } else {
          toast.error(data.data.ResponseMessage);
        }
      })
      .catch((error) => {
        toast.error("Something went wrong");
      })
      .finally(() => {
        setModalLoader(false);
      });
  };

  const handleToggleClick = (rec) => {
    setSelectedPartnerUserForToggle(rec);
    setShowConfirmationModal(true);
  };

  const handleCancel = () => {
    //debugger;
    reset();
    setSelectedPartnerUser({});
    handleResetSelection();
    fetchAccessControlMasterList(null, selectedPartnerDet.Partner_Code);
  };

  // const handleMappingInsert = (data) => {
  //   //debugger;
  //   const updatedList = accessControlMasterList.map(item =>
  //     item.Access_Control_Id === data.Access_Control_Id
  //       ? { ...item, IsSelected: true, IsDeleted: false, UserId: selectedPartnerUser?.UserId }
  //       : item
  //   );
  //   setAccessControlMasterList(updatedList);
  // }

  const [multiSelectKey, setMultiSelectKey] = useState(Date.now());

  // Force remount when accessControlMasterList changes or when we need to clear
  const forceMultiSelectReset = () => {
    setMultiSelectKey(Date.now());
  };

  const handleMappingDelete = (Access_Control_Id) => {
    //debugger;

    // Find the item being deleted
    const itemToDelete = accessControlMasterList.find(
      (item) => item.Access_Control_Id === Access_Control_Id
    );

    if (!itemToDelete) return;

    // Check if any currently selected items depend on the item being deleted
    const dependentItems = accessControlMasterList.filter(
      (item) =>
        item.IsSelected === true &&
        item.Access_Control_Id !== Access_Control_Id && // Not the item being deleted
        item.Is_Dependency === true &&
        item.DependencyParam &&
        item.DependencyParam.split(",")
          .map((name) => name.trim())
          .includes(itemToDelete.Access_Control_Name)
    );

    if (dependentItems.length > 0) {
      let dependencyNames;

      // Check if removing this item would leave any dependent item without dependencies
      const itemsWithUnmetDependencies = dependentItems.filter(
        (dependentItem) => {
          dependencyNames = dependentItem.DependencyParam.split(",").map(
            (name) => name.trim()
          );

          // Check if after deletion, at least one dependency would still be met
          const wouldDependenciesBeMetAfterDeletion = dependencyNames.some(
            (depName) =>
              accessControlMasterList.some(
                (item) =>
                  item.Access_Control_Name === depName &&
                  item.IsSelected === true &&
                  item.Access_Control_Id !== Access_Control_Id // Exclude the item being deleted
              )
          );

          return !wouldDependenciesBeMetAfterDeletion;
        }
      );

      if (itemsWithUnmetDependencies.length > 0) {
        const unmetDependencyNames = itemsWithUnmetDependencies
          .map((item) => item.Access_Control_Name)
          .join(", ");
        alert(
          `At least one from ( ${dependencyNames} ) must remain selected to retain ${unmetDependencyNames}`
        );
        forceMultiSelectReset();
        return;
      }
    }

    // Proceed with deletion
    const updatedList = accessControlMasterList.map((item) =>
      item.Access_Control_Id === Access_Control_Id
        ? {
          ...item,
          IsDeleted: true,
          IsSelected: false,
          UserId: selectedPartnerUser?.UserId,
        }
        : item
    );
    setAccessControlMasterList(updatedList);
  };

  const handleMappingInsert = (data) => {
    //debugger;

    // Check if dependencies need to be validated
    if (data.Is_Dependency === true && data.DependencyParam) {
      // Split the comma-separated dependency parameters
      const dependencyNames = data.DependencyParam.split(",").map((name) =>
        name.trim()
      );

      // Find Access_Control_Names from accessControlMasterList where Is_Dependency === true
      // and their DependencyParam includes any of the dependencyNames
      const dependentAccessControlNames = accessControlMasterList
        .filter(
          (item) =>
            item.Is_Dependency === true &&
            item.DependencyParam &&
            dependencyNames.some((depName) =>
              item.DependencyParam.split(",")
                .map((name) => name.trim())
                .includes(depName)
            )
        )
        .map((item) => item.Access_Control_Name);

      // Check if at least one dependency is selected
      const isDependencyMet = dependencyNames.some((depName) =>
        accessControlMasterList.some(
          (item) =>
            item.Access_Control_Name === depName && item.IsSelected === true
        )
      );

      if (!isDependencyMet) {
        alert(
          `${dependentAccessControlNames} requires selecting ${dependencyNames.join(
            ", "
          )} first`
        );
        forceMultiSelectReset();
        return;
      }
    }

    // Original logic - proceed with selection
    const updatedList = accessControlMasterList.map((item) =>
      item.Access_Control_Id === data.Access_Control_Id
        ? {
          ...item,
          IsSelected: true,
          IsDeleted: false,
          UserId: selectedPartnerUser?.UserId,
        }
        : item
    );
    setAccessControlMasterList(updatedList);
  };

  const handlePartnerSearchChange = (value) => {
    //debugger;
    setPartnerSearch(value);
    if (value.length > 1) {
      const results = activePartnerList.filter((partner) =>
        partner.Partner_Code.toLowerCase().includes(value.toLowerCase())
      );
      setPartnerSearchResults(results);
    } else {
      setPartnerSearchResults([]);
    }
  };

  const handleSelectExtendUser = (user) => {
    setSelectedExtendUser(user);
    setExtendUserSearch(user.FirstName + " " + user.LastName);
    setExtendUserResults([]);
  };

  const handleRoleSelect = (roleId) => {
    setSelectedRoles((prev) =>
      prev.includes(roleId)
        ? prev.filter((id) => id !== roleId)
        : [...prev, roleId]
    );
  };

  // const handleGetPartnerExtensionList = () => {
  //   //console.log(parentPartnerCode, partnerUserId);
  //   PartnerService.GetPartnerExtensionList(parentPartnerCode, partnerUserId)
  //     .then(({ data }) => {
  //       if (data.IsSuccess) {
  //         setPartnerExtensionList(data.Data);
  //       } else {
  //         setPartnerExtensionList([]);
  //       }
  //     })
  //     .catch(() => toast.error("Something went wrong."));
  // };

  return (
    <>
      <>
        <div className="modal-backdrop">
          <div className="modal fade show d-block" tabIndex="-1" role="dialog">
            <div className="modal-dialog modal-lg custom-modal" role="document">
              <div className="modal-content mb-0 p-0">
                <div className="modal-header p-2-5">
                  <h5 className="modal-title">
                    New Staff{" "}
                    {"(" +
                      selectedPartnerDet.Partner_Code +
                      " - " +
                      selectedPartnerDet.Payment_Type +
                      ")"}
                  </h5>
                  <button
                    type="button"
                    className="btn-close"
                    onClick={handleNewPartnerUserClose}
                  ></button>
                </div>
                <div className="modal-body p-1">
                  <form onSubmit={handleSubmit(onSubmit)} autoComplete="off">
                    <div
                      className="container mb-0"
                      style={{ fontSize: "13px" }}
                    >
                      <div className="row">
                        <input
                          type="text"
                          hidden
                          className="form-control"
                          {...register("UserId")}
                          defaultValue={selectedPartnerUser?.UserId || null}
                        />
                        <div className="col-md-4 mb-2">
                          <label className="fw-bold required mb-0-5">
                            First Name
                          </label>
                          <input
                            type="text"
                            className="form-control"
                            placeholder="Enter First Name"
                            {...register("FirstName", {
                              required: "First Name is required",
                            })}
                            defaultValue={selectedPartnerUser?.FirstName || ""}
                          />
                          {errors.FirstName && (
                            <p className="text-danger required_error">
                              {errors.FirstName.message}
                            </p>
                          )}
                        </div>
                        <div className="col-md-4 mb-2">
                          <label className="fw-bold required mb-0-5">
                            Last Name
                          </label>
                          <input
                            type="text"
                            className="form-control"
                            placeholder="Enter Last Name"
                            {...register("LastName", {
                              required: "Last Name is required",
                            })}
                            defaultValue={selectedPartnerUser?.LastName || ""}
                          />
                          {errors.LastName && (
                            <p className="text-danger required_error">
                              {errors.LastName.message}
                            </p>
                          )}
                        </div>
                        <div className="col-md-4 mb-2">
                          <label className="fw-bold required mb-0-5">
                            Mobile No
                          </label>
                          {/* <input type="text" className="form-control" placeholder="Enter Mobile No" {...register("MobileNo")} defaultValue={selectedPartnerUser?.MobileNo || ""} />
                            {errors.MobileNo && <p className="text-danger required_error">{errors.MobileNo.message}</p>} */}
                          <input
                            type="text"
                            placeholder="Enter Mobile No"
                            className="form-control"
                            minLength={10}
                            maxLength={10}
                            defaultValue={selectedPartnerUser?.MobileNo || ""}
                            {...register("MobileNo", {
                              required: "Customer Mobile is required",
                              pattern: {
                                value: /^[0-9]+$/,
                                message: "Only numbers are allowed",
                              },
                              minLength: {
                                value: 10,
                                message:
                                  "Mobile number must be at least 10 digits",
                              },
                              maxLength: {
                                value: 10,
                                message:
                                  "Mobile number must not exceed 10 digits",
                              },
                            })}
                            onInput={(e) =>
                            (e.target.value = e.target.value.replace(
                              /\D/g,
                              ""
                            ))
                            }
                          />
                          {errors.MobileNo && (
                            <p className="text-danger required_error">
                              {errors.MobileNo.message}
                            </p>
                          )}
                        </div>
                      </div>

                      <div className="row">
                        <div className="col-md-4 mb-2">
                          <label className="fw-bold required mb-0-5">
                            Email Id
                          </label>
                          <input
                            type="email"
                            className="form-control"
                            placeholder="Enter Email Id"
                            defaultValue={selectedPartnerUser?.EmailId || ""}
                            {...register("EmailId", {
                              required: "Email Id is required",
                              pattern: {
                                value: /^[^\s@]+@[^\s@]+\.[^\s@]+$/,
                                message: "Invalid email address",
                              },
                            })}
                          />
                          {errors.EmailId && (
                            <p className="text-danger required_error">
                              {errors.EmailId.message}
                            </p>
                          )}
                        </div>
                        {partnerUserInfo?.partnerUserData?.Role_Name ===
                          "Admin" && (
                            <div className="col-md-4 mb-2">
                              <label className="fw-bold mb-0-5">Password</label>
                              <input
                                type="password"
                                className="form-control"
                                disabled
                                placeholder={
                                  selectedPartnerUser?.UserId
                                    ? ""
                                    : "Auto generate password"
                                }
                                {...register("Password")}
                                defaultValue={selectedPartnerUser?.Password || ""}
                              />
                              {errors.Password && (
                                <p className="text-danger required_error">
                                  {errors.Password.message}
                                </p>
                              )}
                            </div>
                          )}
                        <div className="col-md-4 mb-2">
                          <label className="fw-bold required mb-0-5">
                            Role
                          </label>
                          <select
                            className="form-select"
                            {...register("RoleId", {
                              required: "Role is required",
                            })}
                            defaultValue={selectedPartnerUser?.RoleId || ""}
                          >
                            <option value="">Select Role</option>
                            {ActiveRoleList.map((item) => (
                              <option
                                key={item.Role_Id.toString()}
                                value={item.Role_Id.toString()}
                              >
                                {item.Role_Name}
                              </option>
                            ))}
                          </select>
                          {errors.RoleId && (
                            <p className="text-danger required_error">
                              {errors.RoleId.message}
                            </p>
                          )}
                        </div>
                        <div className="col-md-4 mb-2">
                          <label className="fw-bold mb-0-5">Emp Code</label>
                          <input
                            type="text"
                            className="form-control"
                            placeholder="Enter Emp Code"
                            {...register("Emp_Code", {
                              maxLength: {
                                value: 30,
                                message: "Emp Code cannot exceed 30 characters",
                              },
                            })}
                            defaultValue={selectedPartnerUser?.Emp_Code || ""}
                          />
                          {errors.Emp_Code && (
                            <p className="text-danger required_error">
                              {errors.Emp_Code.message}
                            </p>
                          )}
                        </div>
                      </div>

                      <div className="row">
                        <div className="col-md-4 mb-2">
                          <label className="fw-bold required mb-0-5">
                            Partner Code
                          </label>
                          <input
                            type="text"
                            disabled
                            className="form-control"
                            placeholder="Enter Partner Code"
                            {...register("Partner_Code")}
                            defaultValue={
                              selectedPartnerDet?.Partner_Code || ""
                            }
                          />
                        </div>
                        <div className="col-md-4 mb-2" style={{ zIndex: 100 }}>
                          <label className="fw-bold mb-0-5">User Access</label>
                          <MultiSelect
                            key={multiSelectKey}
                            ref={multiSelectRef}
                            options={accessControlMasterList}
                            selectedValues={accessControlMasterList.filter(
                              (access) => access.IsSelected
                            )}
                            displayValue="Access_Control_Name"
                            onSelect={(selectedList, selectedItem) =>
                              handleMappingInsert(selectedItem)
                            }
                            onRemove={(selectedList, removedItem) =>
                              handleMappingDelete(removedItem.Access_Control_Id)
                            }
                            placeholder="Select Allowed Access"
                          />
                        </div>
                        <div className="col-md-4 mb-2">
                          <div className="row mt-4">
                            <div className="col-6">
                              <div className="form-check">
                                <input
                                  type="checkbox"
                                  className="form-check-input"
                                  {...register("IsOtp")}
                                  defaultChecked={
                                    selectedPartnerUser?.IsOtp || false
                                  }
                                />
                                <label className="form-check-label fw-bold">
                                  Is Otp
                                </label>
                              </div>
                            </div>
                            <div className="col-6">
                              <div className="form-check">
                                <input
                                  type="checkbox"
                                  className="form-check-input"
                                  {...register("Is_Partner_Primary_User")}
                                  defaultChecked={
                                    selectedPartnerUser?.Is_Partner_Primary_User ||
                                    false
                                  }
                                />
                                <label className="form-check-label fw-bold">
                                  Is Partner Primary
                                </label>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>

                    <div className="modal-footer mt-0 mb-0 pt-1 pb-0 pr-1">
                      <button
                        type="button"
                        disabled={loading}
                        className="btn btn-danger"
                        onClick={handleCancel}
                      >
                        Cancel
                      </button>
                      <button
                        type="submit"
                        disabled={loading}
                        className="btn custom-sumbitbtn"
                      >
                        {selectedPartnerUser?.UserId
                          ? "Update Staff"
                          : "Add Staff"}
                      </button>
                    </div>
                  </form>
                  <hr className="m-2"></hr>
                  <div className="scrollable-table-wrapper">
                    <div className="table-responsive">
                      <table className="table table-bordered custom-table m-0">
                        <thead>
                          <tr>
                            <th style={{ width: "25%" }}>Partner Staff Name</th>
                            <th style={{ width: "22%" }}>Email Id</th>
                            <th style={{ width: "10%" }}>Mobile No</th>
                            <th style={{ width: "10%" }}>Role Name</th>
                            <th style={{ width: "8%" }}>Active</th>
                            <th style={{ width: "10%" }}>Action</th>
                          </tr>
                        </thead>
                        <tbody>
                          {currentPartnerUsers.length > 0 ? (
                            currentPartnerUsers.map((rec, index) => (
                              <tr key={index}>
                                <td
                                  style={{
                                    textAlign: "center",
                                    verticalAlign: "middle",
                                  }}
                                >
                                  <div
                                    style={{
                                      display: "inline-flex",
                                      alignItems: "center",
                                      justifyContent: "center",
                                    }}
                                  >
                                    {rec.Is_Partner_Primary_User && (
                                      <FaStar
                                        className="text-warning me-1"
                                        title="Primary User"
                                      />
                                    )}
                                    <span>
                                      {rec.FirstName} {rec.LastName}
                                    </span>
                                  </div>
                                </td>

                                <td> {rec.EmailId}</td>
                                <td> {rec.MobileNo}</td>
                                <td> {rec.Role_Name}</td>
                                <td>
                                  {rec.IsActive ? (
                                    <FaToggleOn
                                      title="Deactivate PartnerUser"
                                      className="cursor-pointer"
                                      onClick={() => handleToggleClick(rec)}
                                      color="green"
                                      size={16}
                                    />
                                  ) : (
                                    <FaToggleOff
                                      className="cursor-pointer"
                                      onClick={() => handleToggleClick(rec)}
                                      title="Activate PartnerUser"
                                      color="red"
                                      size={16}
                                    />
                                  )}
                                </td>
                                <td>
                                  <FaPen
                                    color="green"
                                    className="me-2 cursor-pointer"
                                    onClick={() =>
                                      handleViewPartnerUserDetailById(
                                        rec.UserId
                                      )
                                    }
                                    title="Edit PartnerUser"
                                  />
                                  {rec.IsActive && (
                                    <>
                                      <FaKey
                                        color="green"
                                        className="me-2 cursor-pointer"
                                        onClick={() =>
                                          handleStaffSendPassword(rec.UserId)
                                        }
                                        title="Resend Password"
                                      />
                                      { rec.IsActive && rec.Is_Parent &&
                                        <FaUserPlus
                                          size={17}
                                          color="green"
                                          className="cursor-pointer"
                                          title="Extend User"
                                          onClick={() => {
                                            setExtendUserList(true);
                                            setSelectedPartnerUser(rec);
                                          }}
                                        />
                                      }
                                    </>
                                  )}
                                </td>
                              </tr>
                            ))
                          ) : (
                            <tr>
                              <td colSpan="6" className="text-center">
                                No Partner Staff found
                              </td>
                            </tr>
                          )}
                        </tbody>
                      </table>
                    </div>
                  </div>
                </div>
                <div className="modal-footer mt-0 mb-0 pt-1 pb-0 pr-1">
                  <button
                    type="button"
                    className="btn btn-danger"
                    onClick={handleNewPartnerUserClose}
                  >
                    Close
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>

        {extendUserList && (<ExtendUserComponent selectedPartner_Code = {selectedPartnerDet.Partner_Code} selectedPartnerUser= {selectedPartnerUser} setExtendUserList = {setExtendUserList}/>)}

        {showConfirmationModal && (
          <CommonConfirmationModal
            modalLoader={modalLoader}
            setShowConfirmationModal={setShowConfirmationModal}
            description={
              selectedPartnerUserForToggle?.IsActive
                ? "Do you want to deactivate this partner staff?"
                : "Do you want to activate this partner staff?"
            }
            onConfirm={handleConfirmToggle}
          />
        )}
      </>
    </>
  );
};

export default MHL_PartnerUserModalComponent;
